import React from "react";
import { Mail, BookOpen, Star, Instagram, Music2, Facebook } from "lucide-react";
import { OrnamentDivider } from "./Ornaments";

const ITEMS = [
  {
    id: "newsletter",
    label: "Join Newsletter",
    href: "#newsletter",
    aria: "Join the Against All Waves newsletter",
    icon: Mail,
    testId: "link-hub-newsletter",
  },
  {
    id: "purchase",
    label: "Purchase Book Here",
    href: "https://www.amazon.com/Against-All-Waves-Chelsea-Ray-ebook/dp/B0FGTBDNC8/",
    aria: "Purchase Against All Waves on Amazon",
    icon: BookOpen,
    testId: "link-hub-purchase",
    external: true,
  },
  {
    id: "goodreads",
    label: "Follow Me on Goodreads",
    href: "https://www.goodreads.com/author/show/57797883.Chelsea_Ray",
    aria: "Follow Chelsea Ray on Goodreads",
    icon: Star,
    testId: "link-hub-goodreads",
    external: true,
  },
  {
    id: "instagram",
    label: "Follow Me on Instagram",
    href: "https://www.instagram.com/chelsearaywrites",
    aria: "Follow Chelsea Ray on Instagram",
    icon: Instagram,
    testId: "link-hub-instagram",
    external: true,
  },
  {
    id: "tiktok",
    label: "Follow Me on TikTok",
    href: "https://www.tiktok.com/@chelsearaywrites",
    aria: "Follow Chelsea Ray on TikTok",
    icon: Music2,
    testId: "link-hub-tiktok",
    external: true,
  },
  {
    id: "facebook",
    label: "Follow Me on Facebook",
    href: "https://www.facebook.com/profile.php?id=61578028846197",
    aria: "Follow Chelsea Ray on Facebook",
    icon: Facebook,
    testId: "link-hub-facebook",
    external: true,
  },
];

export default function LinkHub() {
  return (
    <section
      id="link-hub"
      data-testid="link-hub"
      className="relative py-24 md:py-32 bg-[#06090e] reveal"
      aria-label="Quick links"
    >
      <div className="parchment-overlay absolute inset-0" aria-hidden="true" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="font-accent text-[10px] text-[#c9a25a] reveal-up">Set Sail</p>
        <h2 className="font-display text-4xl md:text-5xl text-[#f2e8d5] mt-4 reveal-up">
          Follow the Voyage
        </h2>
        <p className="mt-5 text-[#a8b4c0] max-w-xl mx-auto reveal-up">
          Step aboard. Choose your course: newsletter, bookshop, or the
          taverns of social where Elle&rsquo;s and new stories keep unfolding.
        </p>

        <OrnamentDivider />

        <div
          className="flex flex-col items-center gap-4 w-full max-w-md mx-auto reveal-up"
          data-stagger="120"
        >
          {ITEMS.map(({ id, label, href, aria, icon: Icon, testId, external }) => (
            <a
              key={id}
              data-testid={testId}
              data-reveal-child=""
              href={href}
              aria-label={aria}
              {...(external
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
              className="btn-gold w-full justify-between !px-6"
            >
              <span className="flex items-center gap-3">
                <Icon size={15} className="text-[#c9a25a]" aria-hidden="true" />
                <span>{label}</span>
              </span>
              <span aria-hidden="true" className="text-[#c9a25a]/70">
                →
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
